module.exports = __webpack_public_path__ + "img/code.b61b7ff5.jpg";